import React, { useEffect } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import SEO from "../../components/SEO/SEO";
import styles from './DistrictDetail.module.css';

const districtsData = {
  esenler: {
    name: 'Esenler',
    title: 'Esenler Halı Yıkama',
    subtitle: 'Esenler Merkezli Profesyonel Halı ve Koltuk Temizleme Merkezi',
    description: 'Esenler halı yıkama firmaları arasında yılların verdiği tecrübe, müşteri memnuniyeti odaklı yaklaşımımız ve son teknoloji makine parkurumuz ile Diba Halı Yıkama olarak öne çıkıyoruz. Esenler bölgesinde ücretsiz ve 30 dakika içerisinde hızlı servis ağımızla, halılarınızı adresinizden alıp, hijyenik bir şekilde yıkayarak kapınıza kadar teslim ediyoruz.',
    features: ['30 Dakikada Alma', 'Kapıya Teslim', 'Tam Otomatik Yıkama', 'Antibakteriyel Temizlik'],
    stats: { happyCustomers: '2500+', experience: '15 Yıl', rating: '4.9/5' },
    heroGradient: 'linear-gradient(135deg, #1e3a8a, #3b82f6)'
  },
  gungoren: {
    name: 'Güngören',
    title: 'Güngören Halı Yıkama',
    subtitle: 'Güngören Bölgesinin En Güvenilir Halı Yıkama Fabrikası',
    description: 'Güngören halı yıkama hizmetimizde sınır tanımayan kalite anlayışımızla tanışın! Evinizin havasını değiştiren halılarınız, Güngören\'e tahsis edilmiş özel servis araçlarımızla aynı gün alınmaktadır. Çevre dostu deterjanlarla, derinlemesine temizliğin farkını Diba Halı Yıkama kalitesiyle yaşayın.',
    features: ['Aynı Gün Servis', 'Organik Şampuanlar', 'Leke Çıkarma Garantisi', 'Ekonomik Fiyatlar'],
    stats: { happyCustomers: '1800+', experience: '15 Yıl', rating: '4.8/5' },
    heroGradient: 'linear-gradient(135deg, #4338ca, #38bdf8)'
  },
  bagcilar: {
    name: 'Bağcılar',
    title: 'Bağcılar Halı Yıkama',
    subtitle: 'Bağcılar\'da Garantili ve Profesyonel Halı Temizliği',
    description: 'Bağcılar halı yıkama sektörünün lideri olarak, halılarınızın dokusuna özel temizlik programları uyguluyoruz. En zorlu lekelerden, inatçı kirlere kadar her detayı büyük bir titizlikle temizliyor, Bağcılar ilçesinin tüm mahallelerine kesintisiz nakliye hizmeti sunuyoruz. Güveniniz bizim için en değerli referanstır.',
    features: ['Dokuma/Makine Farketmez', 'Geniş Servis Ağı', 'Kuruma ve Havalandırma Odası', 'Sigortalı Yıkama'],
    stats: { happyCustomers: '3200+', experience: '15 Yıl', rating: '4.9/5' },
    heroGradient: 'linear-gradient(135deg, #0f766e, #2dd4bf)'
  },
  bayrampasa: {
    name: 'Bayrampaşa',
    title: 'Bayrampaşa Halı Yıkama',
    subtitle: 'Bayrampaşa İçin Hızlı, Kaliteli ve Ekonomik Çözümler',
    description: 'Bayrampaşa halı yıkama tavsiyesi arayanların ilk tercihi olan firmamız, halılarınızı ilk günkü parlaklığına kavuşturuyor. Kapalı kurutma odalarımızda her mevsime uygun kurutma teknikleri kullanıyor; Bayrampaşa sakinlerine ayrıcalıklı ve tertemiz bir yaşam alanı vadediyoruz.',
    features: ['Hızlı Çözüm', 'Özel Kapalı Kurutma', 'Müşteri Memnuniyeti', 'Dezenfektan Uygulamaları'],
    stats: { happyCustomers: '1500+', experience: '15 Yıl', rating: '4.7/5' },
    heroGradient: 'linear-gradient(135deg, #b91c1c, #f43f5e)'
  },
  zeytinburnu: {
    name: 'Zeytinburnu',
    title: 'Zeytinburnu Halı Yıkama',
    subtitle: 'Zeytinburnu\'nda Leke ve Kir Düşmanı Profesyonel Hizmet',
    description: 'Zeytinburnu halı yıkama arayışınızda kaliteli ve ulaşılabilir fiyat politikamızla yanınızdayız. Avrupa yakasının incisi Zeytinburnu için özel kampanyalarımızla, evlerinizdeki halı, koltuk, yatak ve stor perdeleriniz Diba Halı Yıkama güvencesi altındadır.',
    features: ['Tam Otomatik Yıkama', 'Anti-Alerjik Bakım', 'Stor Perde / Koltuk Temizliği', 'Garantili İşlem'],
    stats: { happyCustomers: '1200+', experience: '15 Yıl', rating: '4.8/5' },
    heroGradient: 'linear-gradient(135deg, #c2410c, #f97316)'
  },
  bahcelievler: {
    name: 'Bahçelievler',
    title: 'Bahçelievler Halı Yıkama',
    subtitle: 'Bahçelievler\'de Antibakteriyel ve Hijyenik Halı Yıkama',
    description: 'Bahçelievler halı yıkama denilince akla gelen kurumsal çözümlerimiz, tüm Bahçelievler sakinlerine layık en üst düzey hijyen sunar. Değerli varlıklarınız olan el dokuması, bambu ve makine halılarınızı iplik yapısına uygun şampuanlarla tertemiz yapıp sizlere hızlıca teslim ediyoruz.',
    features: ['İplik Koruma Sağlayan VIP Yıkama', 'Kusursuz Teslimat', 'Derinlemesine Temizlik', 'Parfümleme'],
    stats: { happyCustomers: '2100+', experience: '15 Yıl', rating: '4.9/5' },
    heroGradient: 'linear-gradient(135deg, #6d28d9, #c084fc)'
  }
};

const DistrictDetail = () => {
  const { district } = useParams();
  const data = districtsData[district];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [district]);

  if (!data) {
    return <Navigate to="/service-areas" />;
  }

  return (
    <div className={styles.districtPage}>
      <SEO title={`${data.title} - Diba Halı Yıkama`} description={data.description} keywords={`${data.name} halı yıkama, ${data.name} koltuk yıkama, ${data.name} stor perde temizliği, profesyonel temizlik, ucuz halı yıkama`} currentUrl={`https://dibahaliyikama.com/#/service-areas/${district}`} />
      {/* Hero Section */}
      <section className={styles.heroSection} style={{ background: data.heroGradient }}>
        <div className="container">
          <div className={styles.heroContent}>
            <span className={styles.badge}>Diba Halı Yıkama Özel Servisi</span>
            <h1 className={styles.title}>{data.title}</h1>
            <p className={styles.subtitle}>{data.subtitle}</p>
            <div className={styles.statsRow}>
              <div className={styles.statBox}>
                <span className={styles.statValue}>{data.stats.happyCustomers}</span>
                <span className={styles.statLabel}>Mutlu Müşteri</span>
              </div>
              <div className={styles.statBox}>
                <span className={styles.statValue}>{data.stats.rating}</span>
                <span className={styles.statLabel}>Müşteri Puanı</span>
              </div>
              <div className={styles.statBox}>
                <span className={styles.statValue}>{data.stats.experience}</span>
                <span className={styles.statLabel}>Sektörel Deneyim</span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.waveDivider}>
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118,130.42,120.31,192.5,109.82C237.94,102.13,281.33,79.52,321.39,56.44Z" className={styles.shapeFill}></path>
          </svg>
        </div>
      </section>

      {/* Main Content Section */}
      <section className={styles.detailsContent}>
        <div className="container">
          <div className={styles.textWrapper}>
            <h2>Neden {data.name} Bölgesinde Biz?</h2>
            <p className={styles.mainDescription}>{data.description}</p>
            
            <h3 className={styles.subHeading}>{data.name} İçin Sürecimiz Nasıl İşler?</h3>
            <div className={styles.stepsGrid}>
              <div className={styles.stepCard}>
                <div className={styles.stepIcon}>📍</div>
                <h4>Ücretsiz Teslim Alma</h4>
                <p>{data.name} içerisindeki adresinizden istediğiniz saatte halılarınızı teslim alıyoruz.</p>
              </div>
              <div className={styles.stepCard}>
                <div className={styles.stepIcon}>🧼</div>
                <h4>Tam Otomatik Yıkama</h4>
                <p>Fabrikamızda, doğaya ve kumaşa zarar vermeyen şampuanlarla özel bir temizlik sürecinden geçirilir.</p>
              </div>
              <div className={styles.stepCard}>
                <div className={styles.stepIcon}>💨</div>
                <h4>Kapalı Kurutma</h4>
                <p>Toz ve dış etkenlere maruz kalmadan kapalı kurutma odalarımızda neminden arındırılır.</p>
              </div>
              <div className={styles.stepCard}>
                <div className={styles.stepIcon}>🚚</div>
                <h4>Ücretsiz Teslimat</h4>
                <p>Parfümlenmiş, poşetlenmiş ve %100 temizlenmiş halılarınız adresinize zamanında ulaştırılır.</p>
              </div>
            </div>

            <h3 className={styles.subHeading}>{data.name} Ayrıcalıkları</h3>
            <ul className={styles.featuresList}>
              {data.features.map((feat, index) => (
                <li key={index}>
                  <i className={`fas fa-check-circle ${styles.checkIcon}`}></i>
                  {feat}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Sticky CTA Footer */}
      <section className={styles.ctaSection}>
        <div className="container">
          <div className={styles.ctaBox}>
            <h2>{data.name} Halı Yıkama Hizmetine Mi İhtiyacınız Var?</h2>
            <p>Mükemmel temizlik için bizimle hemen iletişime geçin, kalitenin keyfini çıkartın.</p>
            <div className={styles.ctaButtons}>
              <a href="tel:+905555555555" className={`btn btn-primary ${styles.actionBtn}`}>
                <i className="fas fa-phone-alt"></i> Hemen Ara
              </a>
              <a href="https://wa.me/905555555555" target="_blank" rel="noopener noreferrer" className={`btn btn-success ${styles.actionBtn} ${styles.whatsappBtn}`}>
                <i className="fab fa-whatsapp"></i> Whatsapp'tan Yaz
              </a>
              <Link to="/contact" className={`btn btn-outline ${styles.actionBtn}`}>
                Adres ve İletişim Bilgileri
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DistrictDetail;